import React from 'react';

const ContactCard = ({ icon, title, value, link }) => {
  return (
    <div className="contact-card">
      <div className="contact-icon">
        {icon}
      </div>
      <h3>{title}</h3>
      <a href={link} target={link.startsWith('http') ? '_blank' : '_self'} rel="noopener noreferrer">
        {value}
      </a>
    </div>
  );
};

export default ContactCard;
